import _get from 'lodash/get'

import {
    PENSIONS_AND_BENEFITS_SAVE_ERROR,
    PENSIONS_AND_BENEFITS_SAVE_SUCCESS,
    PENSIONS_AND_BENEFITS_SAVING,
    PENSIONS_AND_BENEFITS_UPDATE,
} from '../actions'

export default (
    state = {
        shouldFetch: true,
        goToNextQuestion: false,
        goToNextAllowanceQuestion: false,
        isAllowanceUpdate: false,
        activeQuestionIndex: 0,
    },
    action
) => {
    switch (action.type) {
        case PENSIONS_AND_BENEFITS_UPDATE:
            return { ...state, ...action.pensionsAndBenefits }

        case PENSIONS_AND_BENEFITS_SAVING:
            return { ...state, isSaving: true }

        case PENSIONS_AND_BENEFITS_SAVE_SUCCESS:
            return {
                ...state,
                ...action.pensionsAndBenefits,
                isSaving: false,
                goToNextQuestion: true,
                goToNextAllowanceQuestion:
                    action.pensionsAndBenefits.isAllowanceUpdate &&
                    action.pensionsAndBenefits.shouldGoToNextAllowanceQuestion,
                isAllowanceUpdate: false,
                saveError: false,
                errorMessage: '',
                validationErrors: null,
            }

        case PENSIONS_AND_BENEFITS_SAVE_ERROR:
            return {
                ...state,
                ...action.pensionsAndBenefits,
                isSaving: false,
                goToNextQuestion: false,
                goToNextAllowanceQuestion: false,
                saveError: true,
                errorMessage: _get(action, ['errorResponse', 'message'], 'Unknown error occurred'),
                validationErrors: _get(action, ['errorResponse', 'modelState'], false),
            }

        default:
            return state
    }
}
